import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'

const ACDTab = ({ status_name, start_date, end_date, description, isLoading }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      padding={3}
      borderRadius={2}
      backgroundColor="white.main"
    >
      <Box display="flex" gap={10}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography color="light-gray-text.main">Status</Typography>
          <Typography color="light-gray-text.main">Evaluation period</Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={2}>
          {status_name === 'Active' ? (
            <Typography color="positive.main" variant="body1">
              {isLoading ? <Skeleton variant="text" width={100} /> : status_name}
            </Typography>
          ) : (
            <Typography variant="body1">
              {isLoading ? <Skeleton variant="text" width={100} /> : status_name}
            </Typography>
          )}
          {isLoading ? (
            <Skeleton variant="text" width={200} />
          ) : (
            <Typography>
              {start_date} - {end_date}
            </Typography>
          )}
        </Box>
      </Box>
      <Box>
        {description ? (
          <Typography color="light-gray-text.main" mb={0.5}>
            Description
          </Typography>
        ) : null}
        {isLoading ? (
          <>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </>
        ) : (
          <Typography>{description}</Typography>
        )}
      </Box>
    </Box>
  )
}

export default ACDTab
